import React, { useEffect, useState } from 'react';
import { Alert, Badge, Card, Spinner } from '../../../core/ui';
import { Navigate } from 'react-router-dom';
import { useTranslation } from '../../../core/context/TranslationContext';
import { getFamilyCards } from '../api/family';
import { useFamily } from '../context/FamilyContext';
import { memberColor } from '../format';
import { getBankIconBackground, resolveCardColor, BankIcon } from '../../budget/components/cards/bankIcons';
import ScopeSwitcher from './ScopeSwitcher';
import styles from './FamilyCards.module.css';

export default function FamilyCards() {
  const { t } = useTranslation();
  const { family, loading: familyLoading } = useFamily();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!family) return;
    (async () => {
      try {
        setLoading(true);
        const data = await getFamilyCards();
        setCards(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.response?.data?.message || t('error'));
      } finally {
        setLoading(false);
      }
    })();
  }, [family, t]);

  if (familyLoading) return <Spinner className={styles.m4} />;
  if (!family) return <Navigate to="/family/create" replace />;

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <h4 className={styles.heading}>{t('family.cards')}</h4>
        <ScopeSwitcher
          current="family"
          mineRoute="/budget/cards"
          familyRoute="/family/cards"
        />
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? <Spinner /> : (
        <div className={styles.cardGrid}>
          {cards.map(c => (
            <div key={c.id} className={styles.cardCol}>
              <Card
                className={styles.cardItem}
                style={{ borderTop: `3px solid ${resolveCardColor(c)}` }}
              >
                <Card.Body>
                  <div className={styles.cardHeader}>
                    <div className={styles.cardLeft}>
                      <span
                        className={styles.bankIconWrapper}
                        style={{ background: getBankIconBackground(c.bankIcon) || (c.colorHex || '#1e2230') + '33' }}
                      >
                        <BankIcon bankIcon={c.bankIcon} bankName={c.bank} width={64} className={styles.bankIcon} />
                      </span>
                      <div>
                        <div className={styles.bold}>{c.bank}</div>
                        <div className={styles.smallText}>{c.cardName}</div>
                        <div className={styles.mutedSmall}>•••• {c.last4}</div>
                      </div>
                    </div>
                    <Badge style={{ background: memberColor(c.owner?.username || '') }}>
                      {c.owner?.username}
                    </Badge>
                  </div>
                  {c.creditLimit && (
                    <div className={styles.mt2Small}>
                      Limit: {c.currency} {Number(c.creditLimit).toLocaleString()}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </div>
          ))}
          {cards.length === 0 && <p className={styles.muted}>{t('noData')}</p>}
        </div>
      )}
    </div>
  );
}